(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hydroxyl-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSci(sec) {
      sec.classList.add('js-anim');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        sec.classList.add('play');
        return;
      }
      // Safety net: never leave the section invisible if the observer fails to fire.
      var fallback = setTimeout(function () {
        sec.classList.add('play');
      }, 1200);
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              clearTimeout(fallback);
              sec.classList.add('play');
              io.disconnect();
            }
          });
        },
        { threshold: 0.15 },
      );
      io.observe(sec);
    }
    document.querySelectorAll('.sci').forEach(initSci);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-explainer"] && !Shopify.designMode) return;
  try {
    
  class WellisairExplainer extends HTMLElement {
    connectedCallback() {
      if (this.dataset.layout !== 'carousel') return;
      const slides = [...this.querySelectorAll('.wa-exp-slide')];
      if (slides.length < 2) return;

      const frame = this.closest('.wa-exp-frame');
      const prev = frame && frame.querySelector('.wa-exp-arrow--prev');
      const next = frame && frame.querySelector('.wa-exp-arrow--next');
      const dotWrap = frame && frame.querySelector('.wa-exp-dots');

      const current = () => {
        const mid = this.scrollLeft + this.clientWidth / 2;
        let best = 0;
        let bestDist = Infinity;
        slides.forEach((s, i) => {
          const c = s.offsetLeft + s.offsetWidth / 2;
          const d = Math.abs(c - mid);
          if (d < bestDist) {
            bestDist = d;
            best = i;
          }
        });
        return best;
      };

      const goTo = (i) => {
        const t = slides[Math.max(0, Math.min(slides.length - 1, i))];
        this.scrollTo({ left: t.offsetLeft, behavior: 'smooth' });
      };

      let dots = [];
      if (dotWrap) {
        slides.forEach((_, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'wa-exp-dot';
          b.setAttribute('role', 'tab');
          b.setAttribute('aria-label', 'Slide ' + (i + 1) + ' of ' + slides.length);
          b.addEventListener('click', () => goTo(i));
          dotWrap.appendChild(b);
          dots.push(b);
        });
      }

      const sync = () => {
        const i = current();
        const max = this.scrollWidth - this.clientWidth - 1;
        if (prev) prev.disabled = this.scrollLeft <= 0;
        if (next) next.disabled = max <= 0 || this.scrollLeft >= max;
        dots.forEach((d, n) => {
          d.classList.toggle('is-on', n === i);
          d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        });
      };

      if (prev) prev.addEventListener('click', () => goTo(current() - 1));
      if (next) next.addEventListener('click', () => goTo(current() + 1));
      this.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);

      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          stopAuto();
          goTo(current() + 1);
        }
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          stopAuto();
          goTo(current() - 1);
        }
      });

      /* ---------- autoplay ---------- */
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wantsAuto = this.dataset.autoplay === 'true' && !reduce;
      const interval = Math.max(3, parseFloat(this.dataset.interval) || 7) * 1000;
      let timer = null;
      let stopped = false;

      const tick = () => {
        // loop back to the start rather than dead-ending on slide 8
        goTo(current() >= slides.length - 1 ? 0 : current() + 1);
      };
      const startAuto = () => {
        if (!wantsAuto || stopped || timer) return;
        timer = setInterval(tick, interval);
      };
      const pauseAuto = () => {
        clearInterval(timer);
        timer = null;
      };
      // any deliberate interaction ends autoplay for good — don't yank the
      // slide away from someone who has taken control
      const stopAuto = () => {
        stopped = true;
        pauseAuto();
      };

      if (wantsAuto) {
        [prev, next].forEach((b) => b && b.addEventListener('click', stopAuto));
        dots.forEach((d) => d.addEventListener('click', stopAuto));
        this.addEventListener('pointerdown', stopAuto);

        this.addEventListener('mouseenter', pauseAuto);
        this.addEventListener('mouseleave', startAuto);
        this.addEventListener('focusin', pauseAuto);
        this.addEventListener('focusout', startAuto);
        document.addEventListener('visibilitychange', () => {
          document.hidden ? pauseAuto() : startAuto();
        });

        // Only run while the section is on screen. Observe the frame rather than
        // the track — same box, but the frame isn't a scroll container, so its
        // geometry can't be affected by scroll position.
        const watched = frame || this;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(
            (entries) => entries.forEach((e) => (e.isIntersecting ? startAuto() : pauseAuto())),
            { threshold: 0.25 },
          ).observe(watched);
        } else {
          startAuto();
        }
      }

      sync();
    }
  }

  customElements.define('wellisair-explainer', WellisairExplainer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-faq-accordion"] && !Shopify.designMode) return;
  try {
    
  class WellisairFaqAccordion extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.wa-acc-item').forEach((item) => {
        const head = item.querySelector('.wa-acc-head');
        const body = item.querySelector('.wa-acc-body');
        head.addEventListener('click', () => {
          const open = item.classList.toggle('open');
          head.setAttribute('aria-expanded', open);
          body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
        });
      });

      const list = this.querySelector('.wa-faq-list');
      const btn = this.querySelector('.wa-faq-more');
      if (!list || !btn) return;
      const txt = btn.querySelector('.wa-faq-more-txt');
      const total = this.querySelectorAll('.wa-acc-item').length;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      const expand = () => {
        list.classList.remove('clamped');
        btn.setAttribute('aria-expanded', 'true');
        txt.textContent = 'Show fewer questions';
      };
      const collapse = (scroll) => {
        list.classList.add('clamped');
        btn.setAttribute('aria-expanded', 'false');
        txt.textContent = 'Show all ' + total + ' questions';
        if (scroll) {
          const f = this.closest('section');
          if (f) f.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      };
      btn.addEventListener('click', () => (list.classList.contains('clamped') ? expand() : collapse(true)));
    }
  }

  customElements.define('wellisair-faq-accordion', WellisairFaqAccordion);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-flip-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (sec) => {
      const cards = [...sec.querySelectorAll('.wa-flip-card')];
      if (!cards.length) return;

      const setFlipped = (card, on) => {
        card.classList.toggle('is-flipped', on);
        const btn = card.querySelector('.wa-flip-toggle');
        if (btn) btn.setAttribute('aria-expanded', on ? 'true' : 'false');
      };
      const closeAll = () => cards.forEach((c) => setFlipped(c, false));

      /* ---------- auto cycle ----------
         One card open at a time, stepping down the stack: the open card closes
         and the next opens on the same beat. */
      const interval = Math.max(2, parseFloat(sec.dataset.interval) || 7) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const wantsAuto = sec.dataset.autoplay === 'true' && !reduce && cards.length > 1;
      let idx = -1;
      let timer = null;
      let stopped = false;
      let started = false;

      const tick = () => {
        if (idx >= 0) setFlipped(cards[idx], false);
        idx = (idx + 1) % cards.length;
        setFlipped(cards[idx], true);
      };
      const pauseAuto = () => {
        clearInterval(timer);
        timer = null;
      };
      const startAuto = () => {
        if (!wantsAuto || stopped || timer) return;
        // step immediately the first time so the top card opens on arrival,
        // but only resume the timer when returning to view
        if (!started) {
          started = true;
          tick();
        }
        timer = setInterval(tick, interval);
      };
      // a deliberate click means the visitor is driving now
      const stopAuto = () => {
        stopped = true;
        pauseAuto();
      };

      cards.forEach((card) => {
        const btn = card.querySelector('.wa-flip-toggle');
        if (!btn) return;
        btn.addEventListener('click', () => {
          const wasOpen = card.classList.contains('is-flipped');
          stopAuto();
          closeAll(); // keep one-open-at-a-time once the visitor takes over
          setFlipped(card, !wasOpen);
        });
      });

      if (wantsAuto) {
        document.addEventListener('visibilitychange', () => (document.hidden ? pauseAuto() : startAuto()));
        if ('IntersectionObserver' in window) {
          let observed = false;
          new IntersectionObserver(
            (entries) =>
              entries.forEach((e) => {
                observed = true;
                e.isIntersecting ? startAuto() : pauseAuto();
              }),
            { threshold: 0.15 },
          ).observe(sec);
          // A real browser reports within a frame or two. If nothing arrives,
          // run anyway rather than leave the cards frozen on their fronts —
          // never starting is worse than not pausing off screen.
          setTimeout(() => {
            if (!observed) startAuto();
          }, 1200);
        } else {
          startAuto();
        }
      }
    };

    const init = () => document.querySelectorAll('.wa-flip').forEach(initSection);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-founder-video-bio"] && !Shopify.designMode) return;
  try {
    
  class WellisairFounderVideo extends HTMLElement {
    connectedCallback() {
      const v = this.querySelector('video');
      const btn = this.querySelector('.wa-vt-unmute');
      if (!v) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      v.muted = true;
      if ('IntersectionObserver' in window && !reduce) {
        const io = new IntersectionObserver(
          (es) => {
            es.forEach((e) => {
              if (e.isIntersecting) {
                const p = v.play();
                if (p && p.catch) p.catch(() => {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          },
          { threshold: 0.5 },
        );
        io.observe(v);
      }
      if (btn) {
        btn.addEventListener('click', () => {
          v.muted = false;
          if (v.paused) {
            const p = v.play();
            if (p && p.catch) p.catch(() => {});
          }
          btn.classList.add('hidden');
        });
        v.addEventListener('volumechange', () => {
          if (!v.muted) btn.classList.add('hidden');
        });
      }
    }
  }

  customElements.define('wellisair-founder-video', WellisairFounderVideo);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class WellisairHeroSlider extends HTMLElement {
    connectedCallback() {
      const slides = [...this.querySelectorAll('.wa-hero-slide')];
      const dots = [...this.querySelectorAll('.wa-hero-dots .dot')];
      if (!slides.length) return;
      const video = this.querySelector('.wa-hero-video');
      const vIdx = slides.findIndex((s) => s.querySelector && s.querySelector('.wa-hero-video'));
      let i = Math.max(
        0,
        slides.findIndex((s) => s.classList.contains('active')),
      );
      let timer = null;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const onVideo = () => i === vIdx && !!video;

      const stop = () => {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      };
      const schedule = (ms) => {
        stop();
        if (reduce || slides.length < 2) return;
        if (onVideo()) return;
        timer = setTimeout(() => {
          go(i + 1);
          schedule();
        }, ms || 7000);
      };
      const playVideo = () => {
        if (!video || video.tagName !== 'VIDEO') return;
        try {
          video.currentTime = 0;
        } catch (e) {}
        const p = video.play && video.play();
        if (p && p.catch) {
          p.catch(() => {
            if (!reduce) {
              stop();
              timer = setTimeout(() => {
                go(i + 1);
                schedule();
              }, 9000);
            }
          });
        }
      };
      const go = (n) => {
        slides[i].classList.remove('active');
        if (dots[i]) dots[i].classList.remove('active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('active');
        if (dots[i]) dots[i].classList.add('active');
        if (video && video.tagName === 'VIDEO') {
          if (onVideo() && !reduce) playVideo();
          else video.pause();
        }
      };

      if (video && video.tagName === 'VIDEO') {
        video.muted = true;
        const IM =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" stroke="none"/><path d="M16 9l5 6m0-6l-5 6"/></svg>';
        const IS =
          '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 9v6h4l5 4V5L8 9H4z" fill="currentColor" stroke="none"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8 8 0 0 1 0 12"/></svg>';
        const mute = this.querySelector('.wa-hero-mute');
        if (mute) {
          mute.innerHTML = IM;
          mute.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
            video.muted = !video.muted;
            mute.innerHTML = video.muted ? IM : IS;
            mute.setAttribute('aria-pressed', String(!video.muted));
          });
        }
        video.addEventListener('ended', () => {
          if (!reduce) {
            go(i + 1);
            schedule();
          }
        });
      }

      const prevBtn = this.querySelector('.wa-hero-arrow.prev');
      const nextBtn = this.querySelector('.wa-hero-arrow.next');
      if (nextBtn)
        nextBtn.addEventListener('click', () => {
          go(i + 1);
          schedule();
        });
      if (prevBtn)
        prevBtn.addEventListener('click', () => {
          go(i - 1);
          schedule();
        });
      dots.forEach((d, n) =>
        d.addEventListener('click', () => {
          go(n);
          schedule();
        }),
      );
      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', () => schedule());

      if (onVideo() && !reduce) playVideo();
      else schedule();
    }
  }

  customElements.define('wellisair-hero-slider', WellisairHeroSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-lifestyle-slider"] && !Shopify.designMode) return;
  try {
    
  class WellisairLifestyleSlider extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.wa-hs-track');
      if (!track) return;
      const prev = this.querySelector('.wa-hs-arrow.prev');
      const next = this.querySelector('.wa-hs-arrow.next');
      const step = () => {
        const c = track.querySelector('.wa-hs-card');
        if (!c) return 320;
        const g = parseFloat(getComputedStyle(track).gap) || 16;
        return c.getBoundingClientRect().width + g;
      };
      const update = () => {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  customElements.define('wellisair-lifestyle-slider', WellisairLifestyleSlider);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-review-cards"] && !Shopify.designMode) return;
  try {
    
  class WellisairReviewCards extends HTMLElement {
    connectedCallback() {
      const cards = [...this.querySelectorAll('.wa-rc-card')];
      if (cards.length < 2) return;
      const frame = this.closest('.wa-rc-frame');
      const prev = frame && frame.querySelector('.wa-rc-arrow--prev');
      const next = frame && frame.querySelector('.wa-rc-arrow--next');
      if (!prev || !next) return;

      const step = (dir) => {
        const cs = getComputedStyle(this);
        const gap = parseFloat(cs.columnGap || cs.gap) || 0;
        this.scrollBy({ left: (cards[0].getBoundingClientRect().width + gap) * dir, behavior: 'smooth' });
      };
      prev.addEventListener('click', () => step(-1));
      next.addEventListener('click', () => step(1));

      const sync = () => {
        const max = this.scrollWidth - this.clientWidth - 1;
        prev.disabled = this.scrollLeft <= 0;
        next.disabled = max <= 0 || this.scrollLeft >= max;
      };
      this.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
  }

  customElements.define('wellisair-review-cards', WellisairReviewCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-strip-banner"] && !Shopify.designMode) return;
  try {
    
  class WellisairStripBanner extends HTMLElement {
    connectedCallback() {
      const items = [...this.querySelectorAll('.wa-strip-item')];
      // Fewer than 3 strips means advancing would show the same pair again.
      if (items.length < 3) return;

      this.classList.add('is-live');

      const interval = Math.max(2, parseFloat(this.dataset.interval) || 8) * 1000;
      const stagger = Math.max(0, parseFloat(this.dataset.stagger) || 0.7) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Inactive strips are parked off to the side rather than display:none —
      // off-screen content stays in the accessibility tree and remains readable
      // by crawlers, where display:none would drop half the copy.
      const LANE = ['lane-a', 'lane-b'];
      const park = (el) => {
        el.classList.remove('lane-a', 'lane-b', 'is-on');
        el.classList.add('is-parked');
      };
      const show = (el, lane) => {
        el.classList.remove('is-parked');
        el.classList.add(LANE[lane], 'is-on');
      };

      let i = 0;
      items.forEach(park);
      show(items[0], 0);
      show(items[1 % items.length], 1);

      // lane 0 exits left / enters from right; lane 1 mirrors it
      const slide = (outEl, inEl, lane) => {
        if (!outEl || !inEl || outEl === inEl) return;
        const dir = lane === 0 ? 1 : -1;
        inEl.classList.remove('is-parked');
        inEl.classList.add(LANE[lane], 'no-anim');
        inEl.style.setProperty('--x', 100 * dir + '%');
        // force a frame so the entry position is applied before transitioning
        void inEl.offsetWidth;
        inEl.classList.remove('no-anim');
        inEl.classList.add('is-on');
        inEl.style.setProperty('--x', '0%');
        outEl.style.setProperty('--x', -100 * dir + '%');
        const done = () => {
          outEl.removeEventListener('transitionend', done);
          park(outEl);
          outEl.style.setProperty('--x', '0%');
        };
        outEl.addEventListener('transitionend', done);
        // belt and braces: transitionend can be missed if the tab backgrounds
        setTimeout(done, 1200);
      };

      const tick = () => {
        const next = (i + 2) % items.length;
        const a = items[i];
        const b = items[(i + 1) % items.length];
        const na = items[next];
        const nb = items[(next + 1) % items.length];
        slide(a, na, 0);
        window.setTimeout(() => slide(b, nb, 1), reduce ? 0 : stagger);
        i = next;
      };

      let timer = null;
      const start = () => {
        if (!timer) timer = setInterval(tick, interval);
      };
      const stop = () => {
        clearInterval(timer);
        timer = null;
      };

      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          (entries) => entries.forEach((e) => (e.isIntersecting ? start() : stop())),
          { threshold: 0.2 },
        ).observe(this);
      } else {
        start();
      }
    }
  }

  customElements.define('wellisair-strip-banner', WellisairStripBanner);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-tech-carousel"] && !Shopify.designMode) return;
  try {
    
  class WellisairTechCarousel extends HTMLElement {
    connectedCallback() {
      const cards = [...this.querySelectorAll('.wa-cf-card')];
      const dots = [...this.querySelectorAll('.wa-cf-dots .d')];
      const n = cards.length;
      if (!n) return;
      let active = n > 2 ? 1 : 0;
      let timer = null;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      // Five across when there are enough cards to fill the outer slots; with
      // fewer, fall back to three so a card never appears in two places.
      const wide = n >= 5;

      const layout = () => {
        cards.forEach((el, i) => {
          const rel = (i - active + n) % n;
          let slot = 'hidden';
          if (rel === 0) slot = 'center';
          else if (rel === 1) slot = 'right';
          else if (rel === n - 1) slot = 'left';
          else if (wide && rel === 2) slot = 'far-right';
          else if (wide && rel === n - 2) slot = 'far-left';
          el.setAttribute('data-slot', slot);
          // only the front card is reachable; the rest are decorative until clicked
          el.setAttribute('aria-hidden', slot === 'center' ? 'false' : 'true');
        });
        dots.forEach((d, i) => d.classList.toggle('active', i === active));
      };
      const go = (i) => {
        active = (i + n) % n;
        layout();
      };
      const stop = () => {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      };
      const start = () => {
        if (reduce || n < 2) return;
        stop();
        timer = setInterval(() => go(active + 1), 5000);
      };

      cards.forEach((el, i) => {
        el.addEventListener('click', (e) => {
          if (el.getAttribute('data-slot') !== 'center' && e.target.tagName !== 'A') {
            go(i);
            start();
          }
        });
      });
      dots.forEach((d, i) =>
        d.addEventListener('click', () => {
          go(i);
          start();
        }),
      );
      const nextBtn = this.querySelector('.wa-car-arrow.next');
      const prevBtn = this.querySelector('.wa-car-arrow.prev');
      if (nextBtn)
        nextBtn.addEventListener('click', () => {
          go(active + 1);
          start();
        });
      if (prevBtn)
        prevBtn.addEventListener('click', () => {
          go(active - 1);
          start();
        });
      this.addEventListener('mouseenter', stop);
      this.addEventListener('mouseleave', start);
      this.addEventListener('focusin', stop);
      this.addEventListener('focusout', start);
      this.setAttribute('tabindex', '0');
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          go(active + 1);
          start();
        } else if (e.key === 'ArrowLeft') {
          go(active - 1);
          start();
        }
      });
      let sx = null;
      this.addEventListener(
        'touchstart',
        (e) => {
          sx = e.touches[0].clientX;
        },
        { passive: true },
      );
      this.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 40) {
          dx < 0 ? go(active + 1) : go(active - 1);
          start();
        }
        sx = null;
      });

      layout();
      start();
    }
  }

  customElements.define('wellisair-tech-carousel', WellisairTechCarousel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-text-testimonials"] && !Shopify.designMode) return;
  try {
    
  class WellisairTextTestimonials extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.wa-tr-track');
      if (!track) return;
      const prev = this.querySelector('.wa-tr-arrow.prev');
      const next = this.querySelector('.wa-tr-arrow.next');
      const step = () => {
        const c = track.querySelector('.wa-tr-card');
        if (!c) return 320;
        const g = parseFloat(getComputedStyle(track).gap) || 20;
        return c.getBoundingClientRect().width + g;
      };
      const update = () => {
        if (!prev || !next) return;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
      };
      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
  }

  customElements.define('wellisair-text-testimonials', WellisairTextTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-threats-tabs"] && !Shopify.designMode) return;
  try {
    
  class WellisairThreatsTabs extends HTMLElement {
    connectedCallback() {
      const tabs = [...this.querySelectorAll('.wa-tab')];
      const panels = [...this.querySelectorAll('.wa-tabpanel')];
      const activate = (i, focus) => {
        tabs.forEach((t, j) => {
          const s = j === i;
          t.setAttribute('aria-selected', s ? 'true' : 'false');
          t.tabIndex = s ? 0 : -1;
          panels[j].classList.toggle('active', s);
        });
        if (focus) tabs[i].focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => activate(i));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) {
            e.preventDefault();
            activate(n, true);
          }
        });
      });
    }
  }

  customElements.define('wellisair-threats-tabs', WellisairThreatsTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-ugc-testimonials"] && !Shopify.designMode) return;
  try {
    
  class WellisairUgcTestimonials extends HTMLElement {
    connectedCallback() {
      const cards = [...this.querySelectorAll('.wa-ugc-card')];
      if (!cards.length) return;
      const stopExcept = (keep) => {
        cards.forEach((c) => {
          const v = c.querySelector('.wa-ugc-vid');
          if (v && v !== keep) {
            v.pause();
            v.controls = false;
            c.classList.remove('playing');
          }
        });
      };
      cards.forEach((card) => {
        const v = card.querySelector('.wa-ugc-vid');
        const btn = card.querySelector('.wa-ugc-play');
        if (!v || !btn) return;
        btn.addEventListener('click', () => {
          stopExcept(v);
          v.muted = false;
          v.controls = true;
          card.classList.add('playing');
          const p = v.play();
          if (p && p.catch)
            p.catch(() => {
              v.muted = true;
              v.play().catch(() => {});
            });
        });
        v.addEventListener('pause', () => {
          card.classList.remove('playing');
          v.controls = false;
        });
        v.addEventListener('ended', () => {
          card.classList.remove('playing');
          v.controls = false;
        });
      });

      const carousel = this.closest('.wa-ugc-carousel');
      const prevBtn = carousel && carousel.querySelector('.wa-ugc-arrow--prev');
      const nextBtn = carousel && carousel.querySelector('.wa-ugc-arrow--next');
      if (!prevBtn || !nextBtn) return;

      const scrollByCard = (direction) => {
        const trackStyle = getComputedStyle(this);
        const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 0;
        const amount = (cards[0].getBoundingClientRect().width + gap) * direction;
        this.scrollBy({ left: amount, behavior: 'smooth' });
      };
      prevBtn.addEventListener('click', () => scrollByCard(-1));
      nextBtn.addEventListener('click', () => scrollByCard(1));

      const updateArrowState = () => {
        const maxScroll = this.scrollWidth - this.clientWidth - 1;
        prevBtn.disabled = this.scrollLeft <= 0;
        nextBtn.disabled = maxScroll <= 0 || this.scrollLeft >= maxScroll;
      };
      this.addEventListener('scroll', updateArrowState, { passive: true });
      window.addEventListener('resize', updateArrowState);
      updateArrowState();
    }
  }

  customElements.define('wellisair-ugc-testimonials', WellisairUgcTestimonials);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wellisair-video-wall"] && !Shopify.designMode) return;
  try {
    
  class WellisairVideoWall extends HTMLElement {
    connectedCallback() {
      const cards = [...this.querySelectorAll('.wa-vw-card')];
      if (!cards.length) return;

      const stopOthers = (keep) => {
        cards.forEach((c) => {
          const v = c.querySelector('.wa-vw-vid');
          if (v && v !== keep) {
            v.pause();
            v.controls = false;
            c.classList.remove('playing');
          }
        });
      };

      cards.forEach((card) => {
        const v = card.querySelector('.wa-vw-vid');
        const btn = card.querySelector('.wa-vw-play');
        if (!v || !btn) return;

        btn.addEventListener('click', () => {
          stopOthers(v);
          v.controls = true;
          card.classList.add('playing');
          const p = v.play();
          if (p && p.catch) {
            p.catch(() => {
              v.muted = true;
              v.play().catch(() => {});
            });
          }
        });

        v.addEventListener('pause', () => {
          card.classList.remove('playing');
          v.controls = false;
        });
        v.addEventListener('ended', () => {
          card.classList.remove('playing');
          v.controls = false;
        });
      });
    }
  }

  customElements.define('wellisair-video-wall', WellisairVideoWall);

  } catch(e) { console.error(e); }
})();
})();
